(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2390],{

/***/ 57121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconChecklight24 = function SvgIconChecklight24(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "currentColor",
    d: "m10.018 15.586-3.293-3.293-1.414 1.414 4.707 4.707 9.706-9.707-1.413-1.414-8.293 8.293Z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgIconChecklight24);

/***/ }),

/***/ 67679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var TextParser = function(param) {
    var text = param.text;
    if (typeof text !== "string") {
        return text;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: text.split(/\*\*(.*?)\*\*/g).map(function(it, idx) {
            if (idx % 2 === 0) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: it
                }, idx);
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                className: "bg-highlight-gradient",
                children: it
            }, idx);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextParser);


/***/ }),

/***/ 32487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ TrialModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70499);
/* harmony import */ var _components_ui_separator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3127);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35739);
/* harmony import */ var _components_ui_typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58020);







var TrialModal = function(param) {
    var onClose = param.onClose, open = param.open, onActivateTrailClick = param.onActivateTrailClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__/* .Dialog */ .Vq, {
        open: open,
        onOpenChange: function(state) {
            if (state === false) {
                onClose();
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogContent */ .cZ, {
            className: "sm:max-w-[425px] bg-backgroundBrand",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogHeader */ .fK, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogTitle */ .$N, {
                        children: "Ready to activate your 14-day trial now?"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid gap-4 py-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_6__/* .Typography */ .Z, {
                            children: "Enjoy full Challenger plan functionallity free for 14 days."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_6__/* .Typography */ .Z, {
                            children: "Once started you cannot pause or cancel it. During the trial, you can select your membership plan and provide your credit card details. The first payment will be debited and your selected plan will be active after the free 14 days are over."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogFooter */ .cN, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                            variant: "secondary",
                            onClick: onClose,
                            children: "No, not now"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                            onClick: onActivateTrailClick,
                            children: "Activate 14-day trial"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_separator__WEBPACK_IMPORTED_MODULE_4__/* .Separator */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-muted-foreground text-sm",
                    children: [
                        "Check all pricing plans on",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/pricing",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "link-primary",
                                children: "Pricing page"
                            })
                        }),
                        "."
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 57731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _util_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3886);
/* harmony import */ var _TextParser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67679);
/* harmony import */ var _Typography_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57195);
/* harmony import */ var _Typography_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var Typography = function(props) {
    var className = props.className, style = props.style, text = props.text, _as = props.as, as = _as === void 0 ? "p" : _as, onClick = props.onClick;
    if (text === undefined || text === null || text === "") {
        return null;
    }
    var Tag = "".concat(as);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(className, (_Typography_module_scss__WEBPACK_IMPORTED_MODULE_5___default().typography), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (0,_util_styles__WEBPACK_IMPORTED_MODULE_2__/* .utilityClassesGenerator */ .F2)(props))),
        onClick: onClick,
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextParser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            text: text
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Typography);


/***/ }),

/***/ 64345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ol": function() { return /* binding */ CardHeader; },
/* harmony export */   "SZ": function() { return /* binding */ CardDescription; },
/* harmony export */   "Zb": function() { return /* binding */ Card; },
/* harmony export */   "aY": function() { return /* binding */ CardContent; },
/* harmony export */   "eW": function() { return /* binding */ CardFooter; },
/* harmony export */   "ll": function() { return /* binding */ CardTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74183);





var Card = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("rounded-lg border bg-card text-card-foreground shadow-sm", className)
    }, props));
});
Card.displayName = "Card";
var CardHeader = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("flex flex-col space-y-1.5 p-6", className)
    }, props));
});
CardHeader.displayName = "CardHeader";
var CardTitle = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("text-2xl font-semibold leading-none tracking-tight", className)
    }, props));
});
CardTitle.displayName = "CardTitle";
var CardDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("text-sm text-muted-foreground", className)
    }, props));
});
CardDescription.displayName = "CardDescription";
var CardContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("p-6 pt-0", className)
    }, props));
});
CardContent.displayName = "CardContent";
var CardFooter = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)(" flex items-center p-6 pt-0", className)
    }, props));
});
CardFooter.displayName = "CardFooter";



/***/ }),

/***/ 70499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$N": function() { return /* binding */ DialogTitle; },
/* harmony export */   "Be": function() { return /* binding */ DialogDescription; },
/* harmony export */   "GG": function() { return /* binding */ DialogClose; },
/* harmony export */   "Vq": function() { return /* binding */ Dialog; },
/* harmony export */   "cN": function() { return /* binding */ DialogFooter; },
/* harmony export */   "cZ": function() { return /* binding */ DialogContent; },
/* harmony export */   "fK": function() { return /* binding */ DialogHeader; },
/* harmony export */   "hg": function() { return /* binding */ DialogTrigger; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12854);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41352);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74183);
"use client";








var Dialog = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC;
var DialogTrigger = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz;
var DialogClose = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8;
var DialogPortal = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Portal */ .h_, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)(className)
    }, props));
};
DialogPortal.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Portal.displayName */ .h_.displayName;
var DialogOverlay = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay */ .aV, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className)
    }, props));
});
DialogOverlay.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay.displayName */ .aV.displayName;
var DialogContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DialogPortal, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogOverlay, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                ref: ref,
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg md:w-full", className)
            }, props), {
                children: [
                    children,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8, {
                        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            }))
        ]
    });
});
DialogContent.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content.displayName */ .VY.displayName;
var DialogHeader = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("flex flex-col space-y-1.5 text-center sm:text-left", className)
    }, props));
};
DialogHeader.displayName = "DialogHeader";
var DialogFooter = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className)
    }, props));
};
DialogFooter.displayName = "DialogFooter";
var DialogTitle = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("text-lg font-semibold leading-none tracking-tight", className)
    }, props));
});
DialogTitle.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title.displayName */ .Dx.displayName;
var DialogDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description */ .dk, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("text-sm text-muted-foreground", className)
    }, props));
});
DialogDescription.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description.displayName */ .dk.displayName;



/***/ }),

/***/ 58020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Typography; }
/* harmony export */ });
/* unused harmony export typographyVariants */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12003);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88426);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74183);







var typographyVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_2__/* .cva */ .j)("", {
    variants: {
        variant: {
            default: "",
            h1: "scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl",
            h2: "scroll-m-20 pb-2 text-3xl font-semibold tracking-tight transition-colors first:mt-0",
            h3: "scroll-m-20 text-2xl font-semibold tracking-tight",
            h4: "scroll-m-20 text-xl font-semibold tracking-tight",
            h5: "scroll-m-20 text-lg font-semibold tracking-tight",
            h6: "scroll-m-20 text-sm font-semibold tracking-tight",
            p: "leading-7 [&:not(:first-child)]:mt-6",
            blockquote: "mt-6 border-l-2 pl-6 italic",
            lead: "text-xl text-muted-foreground",
            large: "text-lg font-semibold",
            small: "text-sm font-medium leading-none",
            muted: "text-xs text-muted-foreground",
            xs: "text-xs font-medium leading-none"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
var Typography = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, variant = _param.variant, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "variant",
        "asChild"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_4__/* .Slot */ .g7 : "p";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__.cn)(typographyVariants({
            variant: variant,
            className: className
        })),
        ref: ref
    }, props));
});
Typography.displayName = "Typography";



/***/ }),

/***/ 72038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useUnsubscribe; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19475);
/* harmony import */ var _pricing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8637);




var useUnsubscribe = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var auth = (0,_auth__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)();
    var user = auth === null || auth === void 0 ? void 0 : auth.user;
    var subscription = user === null || user === void 0 ? void 0 : user.subscription;
    var futureSubscription = user === null || user === void 0 ? void 0 : user.futureSubscription;
    var subscriptionId = (futureSubscription === null || futureSubscription === void 0 ? void 0 : futureSubscription.id) || (subscription === null || subscription === void 0 ? void 0 : subscription.id);
    var unsubscribe = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var confirmed = window.confirm("Cancel active subscription?");
        if (!confirmed) {
            return;
        }
        (0,_pricing__WEBPACK_IMPORTED_MODULE_3__/* .cancelSubscription */ .EO)(subscriptionId).then(function(response) {
            if ((response === null || response === void 0 ? void 0 : response.status) === "SUCCESS") {
                router.reload(window.location.pathname);
            }
        }).catch(function(err) {
            console.error(err);
        });
    }, [
        subscriptionId
    ]);
    return unsubscribe;
};


/***/ }),

/***/ 3886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cb": function() { return /* binding */ textStylesGenerator; },
/* harmony export */   "F2": function() { return /* binding */ utilityClassesGenerator; },
/* harmony export */   "N0": function() { return /* binding */ spacingsGenerator; },
/* harmony export */   "QZ": function() { return /* binding */ backgroundGenerator; },
/* harmony export */   "VW": function() { return /* binding */ textAlignGenerator; }
/* harmony export */ });
/* unused harmony exports innerSpacingsGenerator, fontSizeGenerator, fontWeightGenerator */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);



var breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
var spacingsGenerator = function(props) {
    var spacingClasses = [
        "m",
        "mt",
        "mb",
        "ms",
        "me",
        "mx",
        "my",
        "p",
        "pt",
        "pb",
        "ps",
        "pe",
        "px",
        "py", 
    ];
    var result = lodash__WEBPACK_IMPORTED_MODULE_0___default().flatten(spacingClasses.map(function(name) {
        return [
            ""
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(breakpoints)).map(function(b) {
            var val = [
                name,
                b
            ].filter(Boolean).join("-");
            return {
                prop: lodash__WEBPACK_IMPORTED_MODULE_0___default().camelCase(val),
                class: val
            };
        });
    }));
    return generator(result, props);
};
var innerSpacingsGenerator = function(props) {
    var spacingClasses = [
        "s"
    ];
    var result = _.flatten(spacingClasses.map(function(name) {
        return [
            ""
        ].concat(_to_consumable_array(breakpoints)).map(function(b) {
            var val = [
                name,
                b
            ].filter(Boolean).join("-");
            return {
                prop: _.camelCase(val),
                class: val
            };
        });
    }));
    return generator(result, props);
};
var textAlignGenerator = function(props) {
    var values = [
        "start",
        "end",
        "center"
    ];
    var result = lodash__WEBPACK_IMPORTED_MODULE_0___default().flatten(values.map(function(name) {
        return [
            ""
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(breakpoints)).map(function(b) {
            var val = [
                "text",
                b
            ].filter(Boolean).join("-");
            return {
                prop: "textAlign" + lodash__WEBPACK_IMPORTED_MODULE_0___default().capitalize(b),
                class: val
            };
        });
    }));
    return generator(result, props);
};
var fontSizeGenerator = function(props) {
    var values = Array(11).fill(0).map(function(_, index) {
        return index + 1;
    });
    var result = lodash__WEBPACK_IMPORTED_MODULE_0___default().flatten(values.map(function(name) {
        return [
            ""
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(breakpoints)).map(function(b) {
            var val = [
                "font-size",
                b
            ].filter(Boolean).join("-");
            return {
                prop: "fontSize" + lodash__WEBPACK_IMPORTED_MODULE_0___default().capitalize(b),
                class: val
            };
        });
    }));
    return generator(result, props);
};
var fontWeightGenerator = function(props) {
    var values = Array(11).fill(0).map(function(_, index) {
        return index + 1;
    });
    var result = lodash__WEBPACK_IMPORTED_MODULE_0___default().flatten(values.map(function(name) {
        return [
            ""
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(breakpoints)).map(function(b) {
            var val = [
                "font-weight",
                b
            ].filter(Boolean).join("-");
            return {
                prop: "fontWeight" + lodash__WEBPACK_IMPORTED_MODULE_0___default().capitalize(b),
                class: val
            };
        });
    }));
    return generator(result, props);
};
var backgroundGenerator = function(props) {
    var result = [
        ""
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(breakpoints)).map(function(b) {
        var val = [
            "bg",
            b
        ].filter(Boolean).join("-");
        return {
            prop: "bgColor" + lodash__WEBPACK_IMPORTED_MODULE_0___default().capitalize(b),
            class: val
        };
    });
    return generator(result, props);
};
var textStylesGenerator = function(props) {
    var result = [
        ""
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(breakpoints)).map(function(b) {
        var val = [
            "text",
            b
        ].filter(Boolean).join("-");
        return {
            prop: "textColor" + lodash__WEBPACK_IMPORTED_MODULE_0___default().capitalize(b),
            class: val
        };
    });
    return generator(result, props);
};
var utilityClassesGenerator = function(props) {
    return [
        backgroundGenerator,
        textStylesGenerator,
        fontSizeGenerator,
        textAlignGenerator,
        spacingsGenerator,
        fontWeightGenerator, 
    ].reduce(function(acc, fn) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, acc, fn(props));
    }, {});
};
var generator = function(classMap, componentProps) {
    var propNames = classMap.reduce(function(acc, value) {
        var key = value.prop || value;
        var className = value.class || value;
        if (componentProps[key] !== undefined) {
            acc["".concat(className, "-").concat(componentProps[key])] = true;
        }
        return acc;
    }, {});
    return propNames;
};


/***/ }),

/***/ 57195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"typography":"Typography_typography__7ugsJ","typography--size-1":"Typography_typography--size-1__f6NK_","typography--size-2":"Typography_typography--size-2__xvWTP","typography--size-3":"Typography_typography--size-3__kL2ye","typography--size-4":"Typography_typography--size-4__TSFro","typography--size-5":"Typography_typography--size-5___qjuA","typography--size-6":"Typography_typography--size-6__OMDPO","typography--size-7":"Typography_typography--size-7__JFWPJ","typography--size-8":"Typography_typography--size-8__4Luee","typography--size-9":"Typography_typography--size-9__KDmf3","typography--size-10":"Typography_typography--size-10__TJ_9K","typography--size-11":"Typography_typography--size-11__4oUn7","typography--size-body":"Typography_typography--size-body__yy1QU","typography--size-subtitle1":"Typography_typography--size-subtitle1__OJuJa","typography--size-subtitle2":"Typography_typography--size-subtitle2__m9eFv","typography--size-subtitle3":"Typography_typography--size-subtitle3___83_p"};

/***/ })

}]);